import React, { useReducer } from 'react';
import StatisticContext from './statisticContext';
import StatisticReducer from './statisticReducer';
import serviceBack from '../../service/serviceBack';
import clienteAxios from '../../service/axios';

import { 
    GET_ALL_INTEGRATOR_SYSTEM,
    OBTENER_USUARIOS_CLIENTE,
    OBTENER_CLIENTES_INTEGRADOR,
    OBTENER_SOPORTES,
    OBTENER_ALERTASXCLIENTE,
    OBTENER_ALERTASXDISTRITO,
    OBTENER_ALERTASENVIADAS,
    OBTENER_DISPOSITIVOSDEVEUI,
    OBTENER_DISPOSITIVOSUBICACION,
    OBTENER_DISPOSITIVOSCLIENTE,
    OBTENER_DISPOSITIVOSMODELO,
    OBTENER_DISPOSITIVOSESTADO,
    OBTENER_DISPOSITVOSPAQUETES,
    OBTENER_DISPOSITVOSPAQUETESPERDIDOS
} from 'types/context';

const StatisticState = props => {
    const initialState = {
        data: null,
        integratorsList:[],
        alertasxcliente: null,
        alertasxdistrito:null,
        alertasenviadas:null,
        usuariosCliente : null,
        clientesIntegrador:null,
        soportes:[],        
    }

    const [ state, dispatch ] = useReducer(StatisticReducer, initialState);


    const getAllIntegratorSystem = async() => {
        
        try{
            const resultado = await serviceBack.get('/statistics/integrators');
            dispatch({
                type: GET_ALL_INTEGRATOR_SYSTEM,
                payload: resultado.data.success ? resultado.data.data : []
            })
            
            if (resultado.data.success)
                return resultado.data.data;
            else return [];

        }catch(err){
            //ver si es necesario hacer algo con el error
            return  []
        }
    }
    
    const obtenerUsuariosPorCliente = async() => {
        
        try{
            const resultado = await clienteAxios.get('/statistics/users');
            dispatch({
                type: OBTENER_USUARIOS_CLIENTE,
                payload: resultado.data.ok ? resultado.data.clientesUsuarios : []
            })
        }catch(err){
            //ver si es necesario hacer algo con el error
            return
        }
    }
    const obtenerClientesPorIntegrador = async() => {
        
        try{
            const resultado = await clienteAxios.get('/statistics/clientes/integrador');
            dispatch({
                type: OBTENER_CLIENTES_INTEGRADOR,
                payload: resultado.data.ok ? resultado.data.integradoresConSusClientes : []
            })
        }catch(err){
            //ver si es necesario hacer algo con el error
            return
        }
    }
    const obtenerClientesPorSoporte = async() => {
        
        try{
            const resultado = await clienteAxios.get('/statistics/clientes/soporte');
            dispatch({
                type: OBTENER_SOPORTES,
                payload: resultado.data.ok ? resultado.data.soportes : []
            })
        }catch(err){
            //ver si es necesario hacer algo con el error
            return
        }
    }
    const obtenerAlertasEnviadas = async( ) => {
        try{
            const resultado = await clienteAxios.get('/statistics/cliente/alertasEnviadas');
            dispatch({
                type: OBTENER_ALERTASENVIADAS,
                payload: resultado.data 
            })
            return resultado.data
        }catch(err){
            //ver si es necesario hacer algo con el error
            return
        }
    }
    const obtenerAlertasCreadas = async( ) => {
        try{
            const resultado = await clienteAxios.get('/statistics/cliente/alertasCreadas');
            dispatch({
                type: OBTENER_ALERTASXCLIENTE,
                payload: resultado.data 
            })
            return resultado.data
        }catch(err){
            //ver si es necesario hacer algo con el error
            return
        }
    }
    const obtenerAlertasDistrito = async( ) => {
        try{
            const resultado = await clienteAxios.get('/statistics/alertasDistrito');
            dispatch({
                type: OBTENER_ALERTASXDISTRITO,
                payload: resultado.data 
            })
            return resultado.data
        }catch(err){
            //ver si es necesario hacer algo con el error
            return
        }
    }
    const obtenerDispositivosDevEUI = async (devEUI, fechaDesde, fechaHasta) => {
        try{
            let resultado ;
            if (devEUI && !fechaDesde){ 
                resultado = await clienteAxios.get(`/statistics/dispositivos`,
                {
                    params: {
                        devEUI: devEUI,
                    },
                  });
            } else if (devEUI && fechaDesde && fechaHasta) {
                resultado = await clienteAxios.get(`/statistics/dispositivos`,
                {
                    params: {
                        devEUI: devEUI,
                        fechaDesde: fechaDesde
                            ? new Date(
                                fechaDesde.getTime() -
                                fechaDesde.getTimezoneOffset() * 60000
                            ).toISOString()
                            : null,
                        fechaHasta: fechaHasta
                            ? new Date(
                                fechaHasta.getTime() -
                                fechaHasta.getTimezoneOffset() * 60000
                            ).toISOString()
                            : null,
                    },
                  }
                );
            } else {
                resultado = await clienteAxios.get(`/statistics/dispositivos`)
            }
            dispatch({
                type: OBTENER_DISPOSITIVOSDEVEUI,
                payload: resultado.data 
            })
            return resultado.data
        }catch(err){
            //ver si es necesario hacer algo con el error
            return
        }
    }
    const obtenerDispositivosClientes = async ()=> {
        try{
            const resultado = await clienteAxios.get('/statistics/clientes/dispositivos');
            dispatch({
                type: OBTENER_DISPOSITIVOSCLIENTE,
                payload: resultado.data 
            })
            return resultado.data
        }catch(err){
            //ver si es necesario hacer algo con el error
            return
        }
    }
    const obtenerDispositivosPorEstado = async ()=> {
        try{
            const resultado = await clienteAxios.get('/statistics/estado/dispositivos');
            dispatch({
                type: OBTENER_DISPOSITIVOSESTADO,
                payload: resultado.data 
            })
            return resultado.data
        }catch(err){
            //ver si es necesario hacer algo con el error
            return
        }
    }
    const obtenerDispositivosPorModelo = async ()=> {
        try{
            const resultado = await clienteAxios.get('/statistics/modelos/dispositivos');
            dispatch({
                type: OBTENER_DISPOSITIVOSMODELO,
                payload: resultado.data 
            })
            return resultado.data
        }catch(err){
            //ver si es necesario hacer algo con el error
            return
        }
    }
    const obtenerPaquetesPorDispositivo = async ()=> {
        try{
            const resultado = await clienteAxios.get('/statistics/paquetes/dispositivos');
            dispatch({
                type: OBTENER_DISPOSITVOSPAQUETES,
                payload: resultado.data 
            })
            return resultado.data
        }catch(err){
            //ver si es necesario hacer algo con el error
            return
        }
    }
    const obtenerPaquetesPerdidos = async ()=> {
        try{
            const resultado = await clienteAxios.get('/statistics/perdidos');
            dispatch({
                type: OBTENER_DISPOSITVOSPAQUETESPERDIDOS,
                payload: resultado.data 
            })
            return resultado.data
        }catch(err){
            //ver si es necesario hacer algo con el error
            return
        }
    }
    const obtenerDispositivoUbicacion = async ()=> {
        try{
            const resultado = await clienteAxios.get('/statistics/dispositivos/ubicacion');
            dispatch({
                type: OBTENER_DISPOSITIVOSUBICACION,
                payload: resultado.data 
            })
            return resultado.data
        }catch(err){
            //ver si es necesario hacer algo con el error
            return
        }
    }


    return(
        <StatisticContext.Provider
            value={{
                data: state.data,
                integratorsList:state.integratorsList,
                usuariosCliente: state.usuariosCliente,
                clientesIntegrador: state.clientesIntegrador,
                soportes: state.soportes,
                alertasxcliente: state.alertasxcliente,
                alertasxdistrito:state.alertasxdistrito,
                alertasenviadas:state.alertasenviadas,
                obtenerUsuariosPorCliente,
                obtenerClientesPorIntegrador,
                obtenerClientesPorSoporte,
                obtenerAlertasEnviadas,
                obtenerAlertasCreadas,
                obtenerAlertasDistrito,
                obtenerDispositivosDevEUI,
                obtenerDispositivosClientes,
                obtenerDispositivosPorEstado,
                obtenerDispositivosPorModelo,
                obtenerPaquetesPorDispositivo,
                obtenerDispositivoUbicacion,
                obtenerPaquetesPerdidos,
                getAllIntegratorSystem
            }}
        >{props.children}

        </StatisticContext.Provider>
    )
}
export default StatisticState;
